export default __webpack_public_path__ + "static/media/ic_branches_b.4297844d.svg";